(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-support"]) return;
  try {
    
// https://platformapi.vesync.com
  const API_BASE_URL = 'https://platformapi.vesync.com';
  const CAPTCHA_API_URL =
    `${API_BASE_URL}/globalPlatform/api/advertisingPlatform/v1/getAdvertisingCaptcha`;
  const SUBMIT_API_URL =
    `${API_BASE_URL}/globalPlatform/api/advertisingPlatform/v1/advertisingEmailUnsubscribe`;

  class SupportCaptchaForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.support-captcha-form__form');
      this.emailInput = this.form.querySelector('[name="email"]');
      this.captchaInput = this.form.querySelector('[name="captcha"]');
      this.imageEl = this.querySelector('.support-captcha-form__image');
      this.refreshBtn = this.querySelector('.support-captcha-form__refresh');
      this.submitBtn = this.querySelector('.support-captcha-form__submit');
      this.errorEl = this.querySelector('.support-captcha-form__message--error');
      this.successEl = this.querySelector('.support-captcha-form__message--success');
      this.captchaKey = '';
      this.isSubmitting = false;
      this._captchaExpireTimer = null;

      this._onSubmit = this._onSubmit.bind(this);
      this._onRefresh = this._onRefresh.bind(this);
      this._onEmailInput = this._onEmailInput.bind(this);

      this.form.addEventListener('submit', this._onSubmit);
      this.refreshBtn.addEventListener('click', this._onRefresh);
      this.emailInput.addEventListener('input', this._onEmailInput);

      this.loadCaptcha();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this._onSubmit);
      this.refreshBtn?.removeEventListener('click', this._onRefresh);
      this.emailInput?.removeEventListener('input', this._onEmailInput);
      this._clearCaptchaExpireTimer();
    }

    _isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    _setFieldError(input, hasError) {
      if (!input) return;
      input.classList.toggle('is-invalid', hasError);
      if (hasError) {
        input.setAttribute('aria-invalid', 'true');
      } else {
        input.removeAttribute('aria-invalid');
      }
    }

    _clearFieldErrors() {
      this._setFieldError(this.emailInput, false);
      this._setFieldError(this.captchaInput, false);
    }

    _onEmailInput() {
      const email = this.emailInput.value.trim();
      if (this.emailInput.classList.contains('is-invalid') && (email === '' || this._isValidEmail(email))) {
        this._setFieldError(this.emailInput, false);
      }
    }

    _getTerminalId() {
      const storageKey = 'support-terminal-id';
      let terminalId = '';

      try {
        terminalId = window.localStorage.getItem(storageKey) || '';
      } catch (error) {
        terminalId = '';
      }

      if (!terminalId) {
        terminalId =
          typeof crypto !== 'undefined' && crypto.randomUUID
            ? crypto.randomUUID()
            : `web-${Date.now()}`;

        try {
          window.localStorage.setItem(storageKey, terminalId);
        } catch (error) {
          // Ignore storage failures and keep the generated ID for this session.
        }
      }

      return terminalId;
    }

    _buildRequestContext(method) {
      return {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles',
        acceptLanguage: document.documentElement.lang || 'en',
        osInfo: 'Web',
        clientInfo: navigator.userAgent || 'Shopify',
        clientType: 'web',
        clientVersion: '1.0.0',
        terminalId: this._getTerminalId(),
        appID: 'eadvoakq',
        sourceAppID: 'levoit-shopify',
        traceId: `WEB${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
        method,
        reqTimestamp: Date.now(),
        token: '',
        module: '',
        debugMode: false,
        invokeType: '',
        accountID: '',
      };
    }

    _buildApiRequest(method, data = {}) {
      return {
        context: this._buildRequestContext(method),
        data,
      };
    }

    _clearCaptchaExpireTimer() {
      if (this._captchaExpireTimer) {
        clearTimeout(this._captchaExpireTimer);
        this._captchaExpireTimer = null;
      }
    }

    _scheduleCaptchaExpiry(expireSeconds) {
      this._clearCaptchaExpireTimer();

      if (!expireSeconds || expireSeconds <= 0) return;

      this._captchaExpireTimer = setTimeout(() => {
        this.captchaKey = '';
      }, expireSeconds * 1000);
    }

    _resolveCaptchaImage(base64) {
      if (!base64) return '';

      if (base64.startsWith('data:') || base64.startsWith('http')) {
        return base64;
      }

      return `data:image/png;base64,${base64}`;
    }

    _clearMessages() {
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
      this.successEl.hidden = true;
      this.successEl.textContent = '';
    }

    _showError(message) {
      this.successEl.hidden = true;
      this.successEl.textContent = '';
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    _showSuccess(message) {
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
      this.successEl.textContent = message;
      this.successEl.hidden = false;
    }

    _setLoading(isLoading) {
      this.isSubmitting = isLoading;
      this.submitBtn.disabled = isLoading;
      this.submitBtn.classList.toggle('is-loading', isLoading);
      this.querySelector('.support-captcha-form__submit-text').hidden = isLoading;
      this.querySelector('.support-captcha-form__submit-loading').hidden = !isLoading;
    }

    _setCaptchaLoading(isLoading) {
      this.refreshBtn.disabled = isLoading;
      this.refreshBtn.classList.toggle('is-loading', isLoading);
    }

    async loadCaptcha({ clearMessages = true } = {}) {
      this._setCaptchaLoading(true);
      if (clearMessages) {
        this._clearMessages();
      }
      this._clearCaptchaExpireTimer();
      this.captchaKey = '';

      try {
        const response = await fetch(CAPTCHA_API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(this._buildApiRequest('getAdvertisingCaptcha')),
        });

        const body = await response.json().catch(() => ({}));

        if (!response.ok || body.code !== 0) {
          throw new Error(body.msg || 'Failed to load verification code.');
        }

        const result = body.result || {};
        const imageSrc = this._resolveCaptchaImage(result.captchaImageBase64);

        if (!result.captchaKey || !imageSrc) {
          throw new Error('Verification image is unavailable.');
        }

        this.captchaKey = result.captchaKey;
        this.imageEl.src = imageSrc;
        this.imageEl.hidden = false;
        this.captchaInput.value = '';
        this._scheduleCaptchaExpiry(result.expireSeconds);
      } catch (error) {
        this.imageEl.hidden = true;
        const message =
          error?.message === 'Failed to fetch'
            ? 'Unable to load verification code. Please check your connection and try again.'
            : error.message || 'Failed to load verification code. Please try again.';
        this._showError(message);
      } finally {
        this._setCaptchaLoading(false);
      }
    }

    _onRefresh() {
      if (this.isSubmitting) return;
      this.loadCaptcha();
    }

    async _onSubmit(event) {
      event.preventDefault();

      if (this.isSubmitting) return;

      this._clearMessages();
      this._clearFieldErrors();

      const email = this.emailInput.value.trim();
      const captchaCode = this.captchaInput.value.trim();

      if (!email) {
        this._showError('Please enter your email address.');
        return;
      }

      if (!this._isValidEmail(email)) {
        this._setFieldError(this.emailInput, true);
        this._showError('This email is invalid');
        return;
      }

      if (!captchaCode) {
        this._showError('Please enter the verification code.');
        return;
      }

      if (!this.captchaKey) {
        this._showError('Verification code expired. Please refresh and try again.');
        await this.loadCaptcha({ clearMessages: false });
        return;
      }

      this._setLoading(true);

      try {
        const response = await fetch(SUBMIT_API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(
            this._buildApiRequest('advertisingEmailUnsubscribe', {
              email,
              captchaKey: this.captchaKey,
              captchaCode,
            })
          ),
        });

        const body = await response.json().catch(() => ({}));

        if (!response.ok || body.code !== 0) {
          throw new Error(body.msg || 'Submission failed. Please try again.');
        }

        // this.form.reset();
        this._clearFieldErrors();
        await this.loadCaptcha({ clearMessages: false });
        this._showSuccess('Submitted successfully!');
      } catch (error) {
        this._showError(error.message || 'Submission failed. Please try again.');
        await this.loadCaptcha({ clearMessages: false });
      } finally {
        this._setLoading(false);
      }
    }
  }

  if (!customElements.get('support-captcha-form')) {
    customElements.define('support-captcha-form', SupportCaptchaForm);
  }

  } catch(e) { console.error(e); }
})();
})();
